export enum ManagerRouteName {
    DashBoardProSkillManager = "dashboard-proSkillManager",
    DashBoardProSkillManagerAssessment = "dashboard-proSkillManager-assessment",
    DashBoardProSkillManagerAssessmentAssessmentId = "dashboard-proSkillManager-assessment-assessmentId",
    DashBoardProSkillManagerCandidate = "dashboard-proSkillManager-candidate",
    DashBoardProSkillManagerResult = "dashboard-proSkillManager-result",
    DashBoardProSkillManagerSubmission = "dashboard-proSkillManager-submission",
    DashBoardProSkillAssureAssessmentSettings = "dashboard-proSkillAssure-manage",
    DashBoardProSkillAssureAssessmentSettingsAssessmentId = "dashboard-proSkillAssure-manage-assessmentId",
    DashBoardProSkillAssureAssessmentSettingsCreate = "dashboard-proSkillAssure-create"
}

